import { Button } from "@/components/ui/button";
import { MessageSquarePlus } from "lucide-react";

interface ChatEmptyStateProps {
    onStartConversation: () => void;
    isCreating?: boolean;
    disabled?: boolean;
}

export function ChatEmptyState({ onStartConversation, isCreating = false, disabled = false }: ChatEmptyStateProps) {
    return (
        <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
            <div className="max-w-md space-y-4">
                <div className="mx-auto w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                    <MessageSquarePlus className="h-8 w-8 text-white" />
                </div>
                
                <div className="space-y-2">
                    <h3 className="text-lg font-semibold">Start a conversation with TurboAI</h3>
                    <p className="text-sm text-muted-foreground">
                        Get instant answers about this claim, ask questions about documents, 
                        estimates, or get help with your claim processing.
                    </p>
                </div>

                <div className="pt-4">
                    <Button 
                        onClick={onStartConversation}
                        disabled={isCreating || disabled}
                        size="lg"
                        className="gap-2"
                    >
                        <MessageSquarePlus className="h-4 w-4" />
                        Start Conversation
                    </Button>
                </div>

                <div className="pt-6 space-y-2 text-xs text-muted-foreground">
                    <p className="font-semibold">Try asking:</p>
                    <ul className="space-y-1">
                        <li>"What's the status of this claim?"</li>
                        <li>"Summarize the uploaded documents"</li>
                        <li>"What are the key discrepancies?"</li>
                        <li>"Help me understand the estimate comparison"</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
